import SettingStore from "stores/settings";
import PublicAdminSettingStore from "stores/publicAdminSettings";

const SETTING_KEY_SHOW_COURSE_IMAGE_IN_PORTAL = "showcourseimageinportal";

export const loadShowCourseImageInPortalDisplaySetting = async (
  mountedRef,
  setDisplayImage,
) => {
  try {
    await PublicAdminSettingStore.init();
    try {
      await SettingStore.init();
    } catch {
      // `v1/adminsettings/` requires auth; anonymous users use public store + fallbacks only
    }

    const fromPublic = PublicAdminSettingStore.getSettingValue(
      SETTING_KEY_SHOW_COURSE_IMAGE_IN_PORTAL,
    );

    const rawValue =
      fromPublic != null
        ? String(fromPublic)
        : SettingStore.getSettingValue(SETTING_KEY_SHOW_COURSE_IMAGE_IN_PORTAL);

    if (mountedRef.current) {
      setDisplayImage(String(rawValue) === "1");
    }
  } catch (error) {
    console.error("Error fetching display setting:", error);
    if (mountedRef.current) {
      setDisplayImage(true);
    }
  }
};
